import { render, staticRenderFns } from "./ModalTutorialGame.vue?vue&type=template&id=33978c2c&"
import script from "./ModalTutorialGame.vue?vue&type=script&lang=js&"
export * from "./ModalTutorialGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports